
export default {
  name: 'BigNewsCard',
  props: {
    news: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    publishFrom() {
      return new Date(this.news.published_at * 1000).toLocaleDateString('ru', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
  },
};
